import type { Language } from "@ui/components/LanguageSelector";

import type { DirectionalIconComponent } from "@jti/brand-icons";

import type { AccountDropdownSettings } from "../../Header";
import type { NavLinks } from "../Navigation";

export type MobileNavToolRowId = "cart" | "store-locator" | "account" | "help" | "search";

export type MobileNavToolRow = {
  id: MobileNavToolRowId;
  label: string;
  href?: string;
  onClick?: () => void;
  icon: DirectionalIconComponent;
  badge?: number;
};

export type MobileNavigationProps = {
  isOpen: boolean;
  onClose: () => void;
  navLinks: NavLinks;
  toolsLinks: MobileNavToolRow[];
  languages: Language[];
  isUserLoggedIn: boolean;
  logoutLabel: string;
  onLogOut: () => void;
  navLabel: string;
  closeLabel: string;
  languageLabel: string;
  searchLabel?: string;
  isSearchOpened?: boolean;
  onOpenSearch?: () => void;
  onCloseSearch?: () => void;
  renderSubmenu?: (id: string) => JSX.Element;
  cartLabel?: string;
  cartItemsCount?: number;
  onCartOpen?: () => void;
  accountDropdownSettings?: AccountDropdownSettings;
  loyaltyPointsCurrency?: string;
};
